import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

/**
 * Modal compacto para alterar endereço da OS (estilo go-dev-confirm).
 */
export default function OrderDetailsAddressEditModal({
  open,
  currentStreet,
  currentLine2,
  addrQuery,
  onQueryChange,
  hits = [],
  searching = false,
  canConfirm = false,
  isSaving = false,
  feedback = null,
  onPick,
  onConfirm,
  onCancel,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const t = window.setTimeout(() => {
      try {
        inputRef.current?.focus();
      } catch {
        /* ignore */
      }
    }, 40);
    return () => window.clearTimeout(t);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !isSaving) onCancel?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, isSaving, onCancel]);

  if (!open) return null;

  return createPortal(
    <div
      className="odm-address-edit-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="odm-address-edit-title"
      data-order-details-portal
    >
      <div className="odm-address-edit-modal">
        <h3 id="odm-address-edit-title" className="odm-address-edit-title">
          Alterar endereço
        </h3>

        <div className="odm-address-edit-current">
          <span className="odm-address-edit-current-label">Atual</span>
          <span className="odm-address-edit-current-value">{currentStreet || '—'}</span>
          {currentLine2 ? (
            <span className="odm-address-edit-current-line2">{currentLine2}</span>
          ) : null}
        </div>

        <div className="odm-address-edit-field">
          <textarea
            ref={inputRef}
            className="odm-address-edit-input"
            rows={2}
            value={addrQuery}
            onChange={(e) => onQueryChange?.(e.target.value)}
            placeholder="Digite rua, número ou CEP…"
            disabled={isSaving}
            autoComplete="off"
            aria-label="Buscar novo endereço"
          />
          {searching ? <div className="odm-address-edit-loading">Buscando…</div> : null}
          {hits.length > 0 ? (
            <div className="odm-address-edit-list" role="listbox">
              {hits.map((hit, i) => {
                const label = String(hit?.display || hit?.texto || '').trim();
                if (!label) return null;
                return (
                  <button
                    key={`${hit?.placeId || label}-${i}`}
                    type="button"
                    className="odm-address-edit-item"
                    onClick={() => onPick?.(hit)}
                    disabled={isSaving}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          ) : null}
        </div>

        {feedback?.type === 'error' ? (
          <p className="odm-address-edit-error">{feedback.message}</p>
        ) : null}

        <div className="odm-address-edit-actions">
          <button
            type="button"
            className="user-form-link-btn user-form-footer-btn"
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="user-form-profile-save-btn user-form-footer-btn"
            onClick={onConfirm}
            disabled={!canConfirm || isSaving}
          >
            {isSaving ? 'Salvando…' : 'Confirmar'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
